export default __webpack_public_path__ + "static/media/cn-eq-icon.ca4788c2.svg";